export class Dashboard {
  ProvideCount: number;
  UserCount: number;
  newRegistrationCount: number;
  reCertifyRegistrationCount: number;
  invoiceCount: number;
  emailTemplateCount: number;
  maintenanceCount: number;
  lifelineApplicantsCount: number;
}